import { render, staticRenderFns } from "./billing-cycle-label.component.vue?vue&type=template&id=b5ac1134&lang=pug"
import script from "./billing-cycle-label.component.vue?vue&type=script&lang=ts"
export * from "./billing-cycle-label.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports